import { css, styled } from '@mui/material';

export const StyledRadioContainer = styled('div')(
  ({ theme }) => css`
    margin-top: ${theme.spacing('LARGE')};
  `
);

export const StyledRadioOptionContainer = styled('div')`
  display: flex;
  cursor: pointer;
  word-break: break-word;
`;
